import { CustomMarker } from 'vue3-google-map';
import mvtCardPoi from '@/common/components/mvtcardpoi/mvt-cardpoi.vue';
import { POI_MARKER_PALETTE } from './poiMarkerPalette.js';

export default {
    name: 'mvtPoiMarker',
    emits: ['markerUnselect', 'markerSelected'],
    components: {
        CustomMarker,
        mvtCardPoi,
    },
    props: {
        position: Object,
        poi: Object,
        disablePopup: {
            type: Boolean,
            default: false,
        },
        autoSelect: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isSelected: false,
            iconMapping: {
                grocery: 'icon-poi-grocery',
                cafes: 'icon-coffee',
                restaurants: 'icon-poi-eat',
                parks: 'icon-park',
                shopping: 'icon-poi-shopping',
                transits: 'icon-poi-bus',
                unknown: 'icon-question-circle',
            },
            isVisibility: false,
            positionX: -50,
            positionY: -50,
            timer: null,
        };
    },
    computed: {
        iconClass() {
            if (this.poi.poiTypeName) {
                if (this.iconMapping.hasOwnProperty(this.poi.poiTypeName)) {
                    return this.iconMapping[this.poi.poiTypeName];
                }
            }
            return this.iconMapping['unknown'];
        },
        markerCssVars() {
            const key = this.poi?.poiTypeName;
            const p = key && POI_MARKER_PALETTE[key];
            if (!p) return {};
            return {
                '--map-marker-color-bg': p.default,
                '--map-marker-color-bg-hover': p.selected,
            };
        },
    },
    methods: {
        setPosition() {
            this.positionX = -50;
            this.positionY = -50;
            if (!this.disablePopup) {
                this.$nextTick(() => {
                    let card = this.$refs.cardRef;
                    let container = card.closest('.mvt-newmap');
                    let containerRect = container.getBoundingClientRect();
                    let cardRect = card.getBoundingClientRect();
                    let cardWidth = cardRect.width;
                    let cardHeight = cardRect.height;
                    let pinRect = this.$refs.markerRef.getBoundingClientRect();
                    let x;
                    let y;

                    if (pinRect.left - containerRect.left < cardWidth / 2) {
                        x = -50 + ((cardWidth / 2 - (pinRect.left - containerRect.left)) * 100) / cardWidth;
                    } else if (containerRect.right - pinRect.right < cardWidth / 2) {
                        x = -50 - ((cardWidth / 2 + (pinRect.right - containerRect.right) - pinRect.width) * 100) / cardWidth;
                    } else {
                        x = -50;
                    }

                    if (containerRect.bottom - cardRect.bottom < cardHeight / 2) {
                        y = -100 - (pinRect.height / cardHeight) * 100;
                    } else {
                        y = (pinRect.height / cardHeight) * 100;
                    }
                    this.positionX = x;
                    this.positionY = y;
                    this.isVisibility = true;
                });
            }
        },
        setSelected(isSelected) {
            if (isSelected !== undefined) {
                this.isSelected = isSelected;
            } else {
                this.isSelected = !this.isSelected;
            }
            if (this.isSelected) {
                // Add event listener when the card becomes visible
                document.addEventListener('click', this.handleClickOutside);
            } else {
                // Remove event listener when the card is hidden
                document.removeEventListener('click', this.handleClickOutside);
            }
        },
        handleClickOutside(event) {
            // Check if the click is outside the dropdown
            if (this.$refs.markerRef && !this.$refs.markerRef.contains(event.target)) {
                this.isSelected = false;
                // Remove event listener after hiding the dropdown
                document.removeEventListener('click', this.handleClickOutside);
            }
        },
    },
    watch: {
        isSelected(isSelected) {
            if (isSelected) {
                this.$emit('markerSelected', this.poi, 'poi');
                this.setPosition();
            } else {
                this.$emit('markerUnselect', this.poi, 'poi');
            }
        },
        autoSelect(newval) {
            if (newval) {
                if (this.timer) {
                    clearTimeout(this.timer);
                }
                this.timer = setTimeout(() => {
                    this.setSelected(true);
                }, 100);
            }
        },
    },
    mounted() {
        if (this.autoSelect) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.setSelected(true);
            }, 100);
        }
    },
    beforeUnmount() {
        // Remove event listener to avoid memory leaks
        document.removeEventListener('click', this.handleClickOutside);
    },
};
